// extracted by mini-css-extract-plugin
export default {"wrapper":"J0-z","play":"K0-z"};